<template>
  <div>
    <JenkinsEdit ref="JenkinsEdit" v-on:editComplete="editComplete"></JenkinsEdit>
      <Card :padding="0" shadow style="margin-bottom: 10px">
        <div slot="title" style="font-weight: bold; color: #000;">
          <Icon type="ios-options"></Icon>
          <span>
            <span> Jenkins列表</span>
            <a v-on:click="edit()" style="float: right"> 添加</a>
          </span>
        </div>
        <CellGroup style="padding: 5px 0;">
          <Alert v-if="listError" type="warning" show-icon>获取数据失败</Alert>
          <div v-else>
            <Cell v-for="item in data"
                  :key="item.id"
                  :title="item.name"
                  :name="item.id"
                  :to="{name: 'jenkins_detail', params: { id: item.id }}"
                  :selected="(item.id).toString() === selected" />
          </div>
        </CellGroup>
      </Card>
  </div>
</template>

<script>
import { getJenkinsAllList, logicDeleteJenkins } from '@/api/tools/jenkins'
import JenkinsEdit from './components/edit'

export default {
  components: {
    JenkinsEdit
  },
  props: {
    currentJenkinsId: {
      type: [Number, String],
      default: null
    }
  },
  data () {
    return {
      tableSearchForm: {
        name: ''
      },
      data: [],
      listError: false
    }
  },
  created: function () {
    this.getData()
  },
  computed: {
    selected () {
      return this.currentJenkinsId ? this.currentJenkinsId.toString() : null
    }
  },
  methods: {
    getData () {
      getJenkinsAllList(this.tableSearchForm).then(res => {
        this.data = res.data
        this.listError = false
      }).catch(res => {
        console.log(res.response)
        this.listError = true
      })
    },
    edit (id) {
      this.$refs.JenkinsEdit.openModal(id || '')
    },
    delete (row) {
      logicDeleteJenkins(row.id).then(res => {
        this.$Notice.success({ title: '操作成功！' })
        this.getData()
      }).catch(res => {
        console.log(res.response)
        if (res.request) {
          this.$Notice.error({
            title: '删除失败！',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '删除失败！'
          })
        }
      })
    },
    clearSearchForm () {
      this.tableSearchForm = {
        name: ''
      }
    },
    // 编辑完成
    editComplete () {
      this.getData()
    }
  }
}
</script>

<style scoped>

</style>
